import { render, staticRenderFns } from "./startEvent.vue?vue&type=template&id=55a7bef4&scoped=true&"
import script from "./startEvent.vue?vue&type=script&lang=js&"
export * from "./startEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a7bef4",
  null
  
)

export default component.exports